<template>
  <div class="user-correction-document">
    <template v-if="showName">
      <p class="has-text-weight-bold mb-1 mt-5">
        {{ document.name }}
      </p>

      <p class="has-text-grey-icon mb-4">
        {{ document.description }}
      </p>
    </template>

    <template v-if="!document.documentId">
      <b-upload drag-drop expanded @input="onUpload">
        <section class="section">
          <div class="content has-text-centered">
            {{ $t("af:my_todo.card.correction.upload.label") }}
          </div>
        </section>
      </b-upload>
    </template>

    <template v-if="uploadedFiles.length > 0">
      <user-correction-document-card
        v-for="(file, index) in uploadedFiles"
        :key="index"
        :upload-mode="true"
        :document-name="file.name"
        :uploaded-file="file"
        @delete="onDelete(index)"
      />
    </template>

    <template v-if="document.documentId">
      <user-correction-document-card
        :upload-mode="false"
        :document-name="document.fileName"
        :document-id="document.documentId"
      />
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserCorrectionDocumentCard from "./UserCorrectionDocumentCard";

export default {
  name: "UserCorrectionDocument",
  components: { UserCorrectionDocumentCard },
  props: {
    document: {
      type: Object,
      required: true,
    },
    showName: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      uploadedFiles: [],
    };
  },
  computed: {
    ...mapGetters({
      getFile: "drawer/getFile",
    }),
  },
  methods: {
    ...mapActions({
      download: "drawer/download",
    }),
    onUpload(file) {
      if (!this.uploadedFiles.includes(file)) {
        this.uploadedFiles.push(file);
      }
    },
    onDelete(index) {
      this.uploadedFiles.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/colors.scss";

.user-correction-document {
  .upload {
    background: $grey-2;

    .upload-draggable:hover.is-primary {
      background: $grey-2 !important;
      border-color: $blue !important;
    }
  }
}
</style>
